/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';

import { FavoriteBorder, FeaturedVideoOutlined, FolderOpen, Search } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

/** @type {Object<string, import('@mui/styles').CSSProperties>} */
const styles = {
  emptyStateContainer: {
    width: '100%',
    minHeight: '400px',
    margin: '0 0 8px 0',
    position: 'relative',
  },

  emptyState: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  emptyStateText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
    margin: '4px',
    fontSize: '15px',
    '& div': {
      margin: '4px',
    },
  },
};

const useStyles = makeStyles(styles);

const TlEmptyResults = ({ messageType, buttonFunction }) => {
  const classes = useStyles();

  const searching = (
    <Box className={classes.emptyStateText}>
      <Box>
        <Search />
      </Box>
      <Box>No search results found!</Box>
      <Box>
        <Button onClick={buttonFunction}>Clear</Button>
      </Box>
    </Box>
  );

  const sourceType = (
    <Box className={classes.emptyStateText}>
      <Box>
        <Search />
      </Box>
      <Box>No source type results found!</Box>
      <Box>
        <Button onClick={buttonFunction}>Clear</Button>
      </Box>
    </Box>
  );

  const following = (
    <Box className={classes.emptyStateText}>
      <Box>
        <FavoriteBorder />
      </Box>
      <Box>You haven't favorited anything yet.</Box>
    </Box>
  );

  const data = (
    <Box className={classes.emptyStateText}>
      <Box>
        <FolderOpen />
      </Box>
      <Box>No data found</Box>
    </Box>
  );

  const ssaiInventory = (
    <Box className={classes.emptyStateText}>
      <Box>
        <FeaturedVideoOutlined />
      </Box>
      <Box>No SSAI Inventory for this content!</Box>
    </Box>
  );

  const extensionInventory = (
    <Box className={classes.emptyStateText}>
      <Box>
        <FeaturedVideoOutlined />
      </Box>
      <Box>No Extension Inventory for this content!</Box>
    </Box>
  );

  const contentStreams = (
    <Box className={classes.emptyStateText}>
      <Box>
        <FeaturedVideoOutlined />
      </Box>
      <Box>No content streams found!</Box>
    </Box>
  );

  return (
    <Box className={classes.emptyStateContainer}>
      <Box className={classes.emptyState}>
        {
          {
            searching,
            following,
            data,
            ssaiInventory,
            extensionInventory,
            sourceType,
            contentStreams,
          }[messageType]
        }
      </Box>
    </Box>
  );
};

TlEmptyResults.defaultProps = {
  buttonFunction: () => {},
};

TlEmptyResults.propTypes = {
  messageType: PropTypes.string.isRequired,
  buttonFunction: PropTypes.func,
};

export default TlEmptyResults;
